<script setup>
import { ref, inject } from 'vue';
import { useLabStore } from '@/stores/lab';
import { storeToRefs } from 'pinia';
import { trans } from 'laravel-vue-i18n';
import { router } from '@inertiajs/vue3';

const { search, destroy } = useLabStore();
const { accessLab: access } = useLabStore();
const { all } = storeToRefs(useLabStore());

const params = ref({
    term: '',
    page: 1,
    sort_by: null,
    per_page: 10,
});

const searchLabs = () => {
    search({
        ...params.value,
    });
};

const modals = inject('modals');

const clearSearch = () => {
    params.value.term = '';
    searchLabs();
};

const tableUpdate = ({ page, sortBy, itemsPerPage }) => {
    Object.assign(params.value, { page, sort_by: sortBy, per_page: itemsPerPage });
    searchLabs();
};

const remove = async (lab) => {
    const confirm = await modals.show('ConfirmationModal', {
        title: trans('label.confirm_delete'),
        prompt: trans('label.are_you_sure_delete'),
    });

    if (confirm) {
        await destroy({ hash: lab.hash });
        searchLabs();
    }
};

const accessLab = async (lab) => {
    await access(lab);
    router.visit('/orders');
};

const openModal = (modal, mode = 'Create', lab = null) => {
    modals.show(modal, {
        props: lab ? {
            lab: lab,
            mode: mode
        } : {
            mode: mode,
        }
    }).then(() => {
        searchLabs();
    });
};
</script>

<template>
<MainContentLayout>
    <template #breadcrumb><BreadCrumb /></template>
    <template #title>{{ $t('label.management_title',{ 'what' : 'Lab' }) }}</template>
    <template #actions>
        <StyledButton @click="openModal('LabsModal')">
            <FontAwesomeIcon icon="plus" class="mr-1" /> {{ $t('label.create') }}
        </StyledButton>
    </template>
    <div class="grid lg:grid-cols-3 md:gap-4 md:mb-4">
        <StyledSearch
            v-model="params.term"
            v-debounce:500ms="searchLabs"
            name="search"
            :label="$t('label.search')"
            :debounce-events="['input']"
            @click:clear="clearSearch" />
    </div>
    <DataTable
        v-if="all"
        :data="all"
        :headers="[
            { title: $t('label.name'), key: 'name' },
            { title: $t('label.status'), key: 'status', value: item => `${item.status.name}` },
        ]"
        :actions="[
            {
                title: $t('label.Edit'),
                icon: 'mdi-pencil',
                action: (item) => openModal('LabsModal', 'Edit', item),
            },
            {
                title: $t('label.Delete'),
                icon: 'mdi-delete',
                action: (item) => remove(item),
            },
            {
                title: $t('label.Access'),
                icon: 'mdi-arrow-right',
                action: (item) => accessLab(item),
            }
        ]"
        @table-update="tableUpdate" />
</MainContentLayout>
</template>
